import request from "@/utils/request";

/**
 *  获取展会列表
 * @param {*}
 * @returns {}
 */
export function getExpoAreaList(params) {
  return request({
    url: "/visitor/getExpoAreaList",
    method: "GET",
    params,
  });
}

/**
 *  获取国家
 * @param {*}
 * @returns {}
 */
export function getCountryList(params) {
  return request({
    url: "/visitor/getCountryList",
    method: "GET",
    params,
  });
}

/**
 *  获取省市区
 * @param {*}  pid
 * @returns {}
 */
export function getRegionList(params) {
  return request({
    url: "/visitor/getRegionList",
    method: "GET",
    params,
  });
}

/**
 * 验证手机或邮箱是否存在
 * @data {*} mobile
 * @data {*} email
 * @returns
 */
export function checkVisitorExist(data) {
  return request({
    url: "/visitor/checkVisitorExist",
    method: "POST",
    data,
  });
}



/**
 * 发送手机验证码
 * @data {*} mobile 手机
 * @data {*} send_type 发送类型 1观众注册 2观众登陆
 * @returns
 */
 export function sendSmsCode(data) {
    return request({
      url: "/visitor/sendSmsCode",
      method: "POST",
      data,
    });
}

/**
 * 发送邮箱验证码
 * @data {*} email 
 * @data {*} send_type 发送类型 1观众注册 2观众登陆
 * @returns
 */
 export function sendEmailCode(data) {
    return request({
      url: "/visitor/sendEmailCode",
      method: "POST",
      data,
    });
}


/**
 * 获取展会状态
 * @returns
 */
 export function getExpoAreaStatus(params) {
  return request({
    url: "/visitor/getExpoAreaStatus",
    method: "GET",
    params,
  });
}


/**
 * 获取产品所属分类树
 * @returns
 */
 export function getIndustryTree(params) {
  return request({
    url: "/visitor/getIndustryTree",
    method: "GET",
    params,
  });
}


/**
 * 更新业务员类型树
 * @returns
 */
 export function getBusinessTree(params) {
  return request({
    url: "/visitor/getBusinessTree",
    method: "GET",
    params,
  });
}


/**
 * 获取兴趣主题
 * @returns
 */
export function getInterestThemeList(params) {
  return request({
    url: "/visitor/getInterestThemeList",
    method: "GET",
    params,
  });
}

/**
 * 获取微信config
 * @returns
 */
export function getWxConfig(params) {
  return request({
    url: "/visitor/getWxConfig",
    method: "GET",
    params,
  });
}
/**
 * 获取微信open_id
 * @returns
 */
export function getWxOpenId(params) {
  return request({
    url: "/visitor/getWxOpenId",
    method: "GET",
    params,
  });
}

/**
 * 电子会刊微信支付
 * @returns
 */
export function getJournalWxJsApiPay(params, headers) {
  return request({
    url: "/journal/getJournalWxJsApiPay",
    method: "GET",
    params,
    headers,
  });
}

/**
 * 获取token
 * @returns
 */
export function getJournalWxJsApiPayToken(params) {
  return request({
    url: "/journal/getJournalWxJsApiPayToken",
    method: "GET",
    params,
  });
}

/**
 * 微信绑定
 * @data {*} code 
 * @returns
 */
export function wxBind(data) {
  return request({
    url: "/visitor/wxBind",
    method: "POST",
    data,
  });
}


/**
 * 微信登录
 * @returns
 */
export function wxLogin(data) {
  return request({
    url: "/visitor/wxLogin",
    method: "POST",
    data,
  });
}

/**
 * 单点登录
 * @returns
 */
export function getVisitorLoginParams(data) {
  return request({
    url: "/visitor/getVisitorLoginParams",
    method: "POST",
    data,
  });
}

/**
 * 创建观众登录token
 * @returns
 */
export function createVisitorLoginToken(data) {
  return request({
    url: "/visitor/createVisitorLoginToken",
    method: "POST",
    data,
  });
}


/**
 * 观众线下峰会微信支付
 * @returns
 */
export function getTicketWxJsApiPay(params) {
  return request({
    url: "/visitor/getTicketWxJsApiPay",
    method: "GET",
    params,
  });
}


/**
 * 观众直播微信支付
 * @returns
 */
export function getLiveWxJsApiPay(params) {
  return request({
    url: "/visitor/getLiveWxJsApiPay",
    method: "GET",
    params,
  });
}

/**
 *  获取sessionId
 * @param {*}
 * @returns {}
 */
export function getChatBotUserId(params) {
  return request({
    url: "https://enwebapi.sialchina.cn/get_chat_bot_user_id",
    method: "GET",
    params,
  });
}